import { axiosInstance } from "../axios/axiosConfig";

const controller = "PaymentMethods";

export const getPaymentMethods = async () => {
  try {
    const response = await axiosInstance.get(`${controller}/active`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
